import { type ReactNode } from "react";

import { loadBundle } from "@doitintl/models-any";
import { useQuery } from "@tanstack/react-query";
import { type AxiosError } from "axios";

import { useApiContext } from "../../api/context";
import { useAuthContext } from "../../Context/AuthContext";

export const LoadBundleData = ({ children }: { children: ReactNode }) => {
  const { userId } = useAuthContext();
  const api = useApiContext();
  const wantJson = !!process.env.REACT_APP_MONGO_BACKEND;

  const { data } = useQuery<ArrayBuffer, AxiosError>({
    queryKey: ["authUserData"],
    queryFn: async () => {
      const { data } = await api.request<ArrayBuffer>({
        method: "get",
        url: "/auth/data/authUserData",
        headers: {
          Accept: wantJson ? "application/json" : "application/octet-stream",
        },
        responseType: wantJson ? "json" : "arraybuffer",
        params: {
          output: wantJson ? "json" : undefined,
        },
      });

      await loadBundle(data);

      return data;
    },
    enabled: !!userId,
    staleTime: 0, // caching comes from browser
  });

  if (!data) {
    return null;
  }

  return <>{children}</>;
};
